<template>
  <div class="page">
    <navigation-bar2 />
    <div class="content">
      <h2>{{ title }}</h2>
      <div class="date">发布日期 : {{ date }}</div>
      <div v-for="(item, index) in content" :key="index">
        <div class="text" v-if="item.type == 'text'">{{ item.value }}</div>
        <div v-if="item.type == 'img'">
          <img :src="imgUrl + item.value" alt="" />
          <div class="imgDesc">{{ item.imgDesc }}</div>
        </div>
      </div>
    </div>
    <bottom-area />
  </div>
</template>

<script>
export default {
  name: "",
  created() {
    this.newsID = this.$route.query.id;
    this.getData();
  },
  components: {
    NavigationBar2: () => import("../nav/NavigationBar2"),
    BottomArea: () => import("../footer/BottomArea"),
  },
  data() {
    return {
      imgUrl: "https://www.baochengtech.com/",
      newsID: "",
      title: "",
      date: "",
      content: [],
    };
  },
  methods: {
    async getData() {
      const { data: res } = await this.$http.get("/newsCenter/detail", {
        params: {
          id: this.newsID,
        },
      });
      if (res.code == 200) {
        console.log(res);
        this.title = res.result.title;
        this.date = res.result.date;
        this.content = res.result.content;
      }
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 1080px;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
  .date {
    font-size: 15px;
    color: #999999;
    margin: 20px 0;
  }
  .text {
    text-align: center;
    text-indent: 2em;
    font-size: 15px;
    margin: 50px 0;
    line-height: 2em;
  }
  .imgDesc {
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 15px;
    color: #999999;
  }
}
</style>
